// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input, textarea {
   cursor: unset !important;
}

:host ::ng-deep .mat-checkbox.mat-checkbox-checked.mat-accent.cdk-focused .mat-checkbox-ripple .mat-ripple-element {
   width: 25px !important;
   height: 25px !important;
   margin-left: 7px;
   margin-top: 7.5px;
}

:host ::ng-deep .mat-checkbox.mat-accent.cdk-focused .mat-checkbox-ripple .mat-ripple-element {
   width: 25px !important;
   height: 25px !important;
   margin-left: 7px;
   margin-top: 7.5px;
}

.field-container {
   display: flex;
   flex-direction: column;
}

.choice-field-body {
   border-style: none;
   overflow: unset;
}


.choice-layout-0, .choice-layout-1 {
   margin: 0 2px 0 12px !important;
}

.c-validation {
   font-weight: normal;
   font-size: 0.8125em;
   line-height: 1.3em;
   margin-top: -10px;
   margin-left: 12px;
   margin-right: 10px;
   color: red;
}

::ng-deep .choice-field-body .choice-layout-0 .mat-checkbox-layout,
::ng-deep .choice-field-body .choice-layout-1 .mat-checkbox-layout {
   cursor: context-menu !important;
}

::ng-deep .mat-checkbox-frame {
   border-color: #808080;
}

.div-checkbox {
   margin-bottom: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-generate/field-type/checkbox/checkbox.component.css"],"names":[],"mappings":"AAAA;GACG,wBAAwB;AAC3B;;AAEA;GACG,sBAAsB;GACtB,uBAAuB;GACvB,gBAAgB;GAChB,iBAAiB;AACpB;;AAEA;GACG,sBAAsB;GACtB,uBAAuB;GACvB,gBAAgB;GAChB,iBAAiB;AACpB;;AAEA;GACG,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,kBAAkB;GAClB,eAAe;AAClB;;;AAGA;GACG,+BAA+B;AAClC;;AAEA;GACG,mBAAmB;GACnB,mBAAmB;GACnB,kBAAkB;GAClB,iBAAiB;GACjB,iBAAiB;GACjB,kBAAkB;GAClB,UAAU;AACb;;AAEA;;GAEG,+BAA+B;AAClC;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,kBAAkB;AACrB","sourcesContent":["input, textarea {\n   cursor: unset !important;\n}\n\n:host ::ng-deep .mat-checkbox.mat-checkbox-checked.mat-accent.cdk-focused .mat-checkbox-ripple .mat-ripple-element {\n   width: 25px !important;\n   height: 25px !important;\n   margin-left: 7px;\n   margin-top: 7.5px;\n}\n\n:host ::ng-deep .mat-checkbox.mat-accent.cdk-focused .mat-checkbox-ripple .mat-ripple-element {\n   width: 25px !important;\n   height: 25px !important;\n   margin-left: 7px;\n   margin-top: 7.5px;\n}\n\n.field-container {\n   display: flex;\n   flex-direction: column;\n}\n\n.choice-field-body {\n   border-style: none;\n   overflow: unset;\n}\n\n\n.choice-layout-0, .choice-layout-1 {\n   margin: 0 2px 0 12px !important;\n}\n\n.c-validation {\n   font-weight: normal;\n   font-size: 0.8125em;\n   line-height: 1.3em;\n   margin-top: -10px;\n   margin-left: 12px;\n   margin-right: 10px;\n   color: red;\n}\n\n::ng-deep .choice-field-body .choice-layout-0 .mat-checkbox-layout,\n::ng-deep .choice-field-body .choice-layout-1 .mat-checkbox-layout {\n   cursor: context-menu !important;\n}\n\n::ng-deep .mat-checkbox-frame {\n   border-color: #808080;\n}\n\n.div-checkbox {\n   margin-bottom: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
